module.exports = {"340121100":"水湖镇","340121101":"庄墓镇","340121102":"杨庙镇","340121103":"吴山镇","340121104":"岗集镇","340121105":"双墩镇","340121106":"下塘镇","340121107":"朱巷镇","340121109":"陶楼镇","340121110":"杜集镇","340121111":"义井镇","340121112":"左店镇","340121200":"罗塘乡","340121203":"造甲乡","340121400":"双凤开发区","340121401":"安徽省水家湖农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340121.json
// module id = 1142
// module chunks = 0